import { Component } from 'shimmer'

import { VirtualScroll } from '@/utils/VirtualScroll'
import { clamp } from '@/utils/Maths'

import { Vector3, CatmullRomCurve3, Line } from 'three'

const factorScroll = 25
const factorPointerPos = .8

export class CameraAnimation extends Component {
  constructor (camera, animationClip) {
    super()

    this.onScroll = this.onScroll.bind(this)

    this.camera = camera
    this.animationClip = animationClip
    this.animationFrameLength = 0
    this.frameIndex = 0

    this.animationPosition = this.animationClip.tracks.find(track => track.name.includes('position'))
    this.animationQuaternion = this.animationClip.tracks.find(track => track.name.includes('quaternion'))
    this.animationFrameLength = this.animationPosition.times.length

    this.curvesPosition = this.factoryCurve(this.animationPosition, 3)
    this.curvesQuaternion = this.factoryCurve(this.animationQuaternion, 4)

    this.scroll = new VirtualScroll({ smooth: .05, clamp: { min: 0, max: this.animationFrameLength * factorScroll} })
    this.scroll.onSmoothScroll(this.onScroll)

    this.onScroll({ progress: 0 })

    this.isActive = false
    this.pointer = {x: 0, y:0}
    this.delta = 0
  }

  onScroll ({ progress }) {
    progress = progress > 0.998 ? 0.998 : progress
    this.pos = this.curvesPosition.xyz.getPoint(progress)

    this.quatXYZ = this.curvesQuaternion.xyz.getPoint(progress)
    this.quatW = this.curvesQuaternion.w.getPoint(progress)
  }

  onUpdate () {
    this.camera.position.x = this.pos.x
    this.camera.position.y = this.pos.y
    this.camera.position.z = this.pos.z

    this.camera.quaternion.x = this.quatXYZ.x
    this.camera.quaternion.y = this.quatXYZ.y
    this.camera.quaternion.z = this.quatXYZ.z
    this.camera.quaternion.w = this.quatW.x

    this.camera.rotateY(-this.pointer.x * factorPointerPos)
    this.camera.rotateX(this.pointer.y * factorPointerPos)
  }

  factoryCurve (frameTracks, base) {
    const positions = []

    for (let i = 0; i < this.animationFrameLength; i++) {
      positions.push({
        x: frameTracks.values[i * base],
        y: frameTracks.values[i * base + 1],
        z: frameTracks.values[i * base + 2],
        w: base === 4 ? frameTracks.values[i * base + 3] : null
      })
    }

    return {
      xyz: new CatmullRomCurve3(positions.map(pos => new Vector3(pos.x, pos.y, pos.z)), false),
      w: base === 4 ? new CatmullRomCurve3(positions.map(pos => new Vector3(pos.w, 0, 0)), false) : null
    }
  }

  set pointerPosition (value) {
    this.pointer = value
  }

  get active () {
    return this.isActive
  }

  set active (value) {
    this.isActive = value
  }
}